<script lang="ts">
import FooterVue from "@/Components/Generics/Footer.vue";
import { defineComponent } from "vue";

export default defineComponent({
    components: {
        FooterVue,
    },
});
</script>

<template>
    <div class="d-flex flex-column min-vh-100">
        <slot name="navigation"></slot>

        <div class="content content-width">
            <slot name="content"></slot>
            <div class="spacer"></div>
        </div>

        <div class="mt-auto">
            <FooterVue />
        </div>

        <a href="mailto:contact@deinjobfuchs.de" class="help-button text text--size-22 text--semi-bold text--color-white">{{ $trans("navigation.help-button") }}</a>

        <div id="modal-wrapper"></div>
    </div>
</template>

<style lang="scss" scoped>
.help-button {
    position: fixed;
    z-index: 10;
    bottom: rem(100);
    right: rem(-20);
    // transform: translateX(120%);

    padding: rem(10) rem(30);
    padding-right: rem(50);
    border-radius: rem(8);
    box-shadow: 0 rem(3) 0 0 #00000028;
    min-height: rem(40);
    max-width: rem(300);
    border-radius: rem(20);
    pointer-events: all;
    cursor: pointer;

    border: none;

    background-image: $primary-gradient;
    &:hover {
        background-image: $primary-gradient-lighter;
    }
}
@include media-breakpoint-down(lg) {
    .help-button {
        display: none;
    }
}
</style>
